enum CycleMeasurementSymbol {
  Celsius = '°C',
  Fahrenheit = '°F',
}

export default CycleMeasurementSymbol;
